import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { MailingListService } from '@mailer/services/MailingListService';
import ItemForm from './sms-parts-table';
import i18n from '@app/plugins/i18n';

class StatsModalService extends ModalService {
  constructor() {
    super(MailingListService);
  }

  view(part_group) {
    return this.$open({
      title: i18n.t('mailer.mailing.modal.view.title'),
      width: this.size.large,
      loading: true,
      render: (h) =>
        h(ItemForm, {
          props: {
            id: part_group
          },
          on: {
            success: (data) => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new StatsModalService();
export { instance as StatsModalService };
